import { Box, Typography } from "@mui/material";
import type { FC } from "react";
import { useThemePreference } from "../../theme/ThemePreferenceProvider";
import { INK, SURFACE } from "../../theme/tokens";

// In-House brand purple (the dot-circle mark's color). Fixed brand hue, not theme-driven.
const IN_HOUSE_PURPLE = "#3D127F";

/**
 * Full-width "Powered by [In-House dot] In-House Health" footer bar at the bottom of the app,
 * with a top divider separating it from the content. Shown only when the UKG-Plain logo is
 * active (Plain drops In-House from the header, so the footer re-adds the attribution).
 */
export const PoweredByFooter: FC = () => {
	const { logo } = useThemePreference();
	if (logo !== "ukg-plain") return null;

	return (
		<Box
			component="footer"
			sx={{
				width: "100%",
				display: "flex",
				alignItems: "center",
				gap: 1,
				px: 2,
				py: 1,
				borderTop: "1px solid",
				borderColor: "divider",
				backgroundColor: SURFACE,
			}}
		>
			<Typography sx={{ color: INK.PRIMARY, fontSize: "14px", fontWeight: 500 }}>Powered by</Typography>
			<Box component="img" src="/base-icon.png" alt="" sx={{ height: 20, width: "auto" }} />
			<Typography sx={{ color: IN_HOUSE_PURPLE, fontSize: "15px", fontWeight: 700 }}>In-House Health</Typography>
		</Box>
	);
};
